module.exports = __webpack_public_path__ + "img/full-logo.f6402d7b.svg";